import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { formatAsOfFilterDateOnly } from '@dealstack/frontend/shared/utils/utc.ts';
import { parseBEDateIgnoreTimezone } from '@dealstack/shared/lib/format/dates/date';

export const CapHeaderContext = React.createContext<ReturnType<typeof useCapPageHeaderController>>(
	{} as ReturnType<typeof useCapPageHeaderController>
);

export const useCapPageHeaderController = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const filterDate = searchParams.get('filterDate');

	const setFilterDate = (date: Date | null) => {
		const formattedDate = formatAsOfFilterDateOnly(date);
		if (formattedDate) {
			setSearchParams({ filterDate: formattedDate });
		} else {
			setSearchParams({});
		}
	};

	return {
		formattedDate: filterDate || null,
		filterDate: filterDate ? parseBEDateIgnoreTimezone(filterDate) : null,
		setFilterDate,
	};
};
